import { useMemo } from 'react';
import { useGetRepairWorkInProgressData } from './api/useGetRepairWorkInProgressData';
import { RepairProgressImageInfoType } from '@/types/bodyAndPaint';

interface RepairImageCheckDataHookProps {
  inspectionID: number;
}
export const useRepairImageCheckData = ({
  inspectionID,
}: RepairImageCheckDataHookProps) => {
  const { damagePartList } = useGetRepairWorkInProgressData({
    t_pm_car_inspection_id: inspectionID,
  });
  const repairImageCheckData = useMemo(() => {
    const dataList = damagePartList?.working_list ?? [];

    const repairItemList = dataList.reduce((list, item) => {
      const [defectedItem] = item.body_paint_defect;
      const damagePartList = [
        defectedItem?.front_side_left ? '前方部分 左側の損傷' : '',
        defectedItem?.front_side_center ? '前方部分 中央の損傷' : '',
        defectedItem?.front_side_right ? '前方部分 右側の損傷' : '',
        defectedItem?.front_door_left ? '前ドア部分 左側の損傷' : '',
        defectedItem?.front_door_right ? '前ドア部分 右側の損傷' : '',
        defectedItem?.rear_door_left ? '後ドア部分 左側の損傷' : '',
        defectedItem?.rear_door_right ? '後ドア部分 右側の損傷' : '',
        defectedItem?.rear_side_left ? '後方部分 左側の損傷' : '',
        defectedItem?.rear_side_center ? '後方部分 中央の損傷' : '',
        defectedItem?.rear_side_right ? '後方部分 右側の損傷' : '',
      ].filter((item) => item !== '');
      const imageUrlList = Object.values(defectedItem?.image_lists ?? {});

      const listItem: RepairProgressImageInfoType = {
        damage_part: damagePartList,
        damage_desc: defectedItem?.damage_detail,
        repair_item_list: [item.t_pm_car_inspection_need_maintenance_name],
        image_url_list: imageUrlList,
        progress_item: Object.values(item.working_process),
      };
      list.push(listItem);
      return list;
    }, [] as RepairProgressImageInfoType[]);
    return repairItemList;
  }, [damagePartList]);

  return { repairImageCheckData };
};
